export const firstOrSelf = item => (Array.isArray(item) ? item[0] : item)

export function forceDownload(blob, name) {
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  document.body.appendChild(link)
  link.style.display = 'none'
  link.href = blobUrl
  link.download = name
  link.click()
  URL.revokeObjectURL(blobUrl)
}

export function classNames(...args) {
  const classes = []

  args.forEach(arg => {
    if (arg) {
      if (typeof arg === 'string' || typeof arg === 'number') {
        classes.push(arg)
      } else if (Array.isArray(arg) && arg.length) {
        const inner = classNames(...arg)

        if (inner) {
          classes.push(inner)
        }
      } else if (typeof arg === 'object' && arg !== null) {
        Object.entries(arg).forEach(([key, value]) => {
          if (value) {
            classes.push(key)
          }
        })
      }
    }
  })

  return classes.join(' ')
}

// Object
export const fillObject = (obj, value) =>
  Object.entries(obj).reduce(
    (acc, [k, v]) => ({ ...acc, [k]: v instanceof Object ? fillObject(v, value) : value }),
    {},
  )

export const isObject = v => v instanceof Object && !(v instanceof Array) && !(v instanceof Date)

export const pick = (ks, o) => {
  const copy = {}
  ks.forEach(k => {
    copy[k] = o[k]
  })
  return copy
}

export function isEqual(a, b, keys) {
  if (!keys) {
    return JSON.stringify(a) === JSON.stringify(b)
  }

  return JSON.stringify(pick(keys, a)) === JSON.stringify(pick(keys, b))
}

export const isEmptyOrDefault = (v, ignoreNull) =>
  (v === null && !ignoreNull) ||
  v === undefined ||
  (v instanceof Array && v.length === 0) ||
  (isObject(v) && isEqual(v, {})) ||
  (typeof v === 'string' && v.trim() === '')

export const cleanObject = obj =>
  Object.entries(obj)
    .map(([k, v]) => (isObject(v) ? [k, cleanObject(v)] : [k, v]))
    .filter(([, v]) => !isEmptyOrDefault(v))
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})

// Fn
export function debounce(fn, time) {
  let timeout

  return (...args) => {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => fn.apply(context, args), time)
  }
}

// export const mergeObjectOnlyKeys = (obj1, obj2) => {
//   Object.keys(obj2).forEach(function(key) {
//     if (key in obj1) {
// or obj1.hasOwnProperty(key)
//       obj1[key] = obj2[key]
//     }
//   })

//   return obj1
// }

export const mergeObjectOnlyKeys = (obj1, obj2) => {
  return Object.keys(obj2).reduce(
    (acc, key) => {
      if (key in obj1) {
        acc[key] = obj2[key]
      }
      return acc
    },
    { ...obj1 },
  )
}

export const objectToFormData = function(obj, form, namespace) {
  var fd = form || new FormData()
  var formKey

  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (namespace) {
        formKey = namespace + '[' + property + ']'
      } else {
        formKey = property
      }

      // if the property is an object, but not a File,
      // use recursivity.
      if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        objectToFormData(obj[property], fd, property)
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property])
      }
    }
  }

  return fd
}

export const objectDiff = (obj1, obj2) => {
  return Object.keys(obj1).reduce((diffObj, key) => {
    if (obj1[key] !== obj2[key]) {
      diffObj[key] = obj2[key]
    }
    return diffObj
  }, {})
}

export const readFileAsDataURL = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      resolve(reader.result)
    }

    reader.onerror = error => {
      reject(error)
    }

    reader.readAsDataURL(file)
  })
}
